import React, { useState } from "react";
import {
  User,
  Lock,
  ShieldCheck,
  LogIn
} from "lucide-react";

import "./Login.css";

export default function Login({ onLoginSuccess }) {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLoginSubmit = (e) => {

    e.preventDefault();

    const sanitizedUser = username.trim();
    const sanitizedPass = password.trim();

    if (
      sanitizedUser === "admin" &&
      sanitizedPass === "admin123"
    ) {

      onLoginSuccess();

    } else {

      alert(
        "Invalid Username or Password."
      );

    }

  };

  return (

    <div className="login-page">

      <div className="login-background">

        <div className="circle one"></div>

        <div className="circle two"></div>

        <div className="circle three"></div>

      </div>

      <div className="login-card">

        <div className="login-logo">

          <ShieldCheck size={42} />

        </div>

        <h1>

          Tally Messenger

        </h1>

        <h2>

          Subscription Management

        </h2>

        <p>

          Secure administrator access

        </p>

        <form
          className="login-form"
          onSubmit={handleLoginSubmit}
        >

          <div className="input-group">

            <label>

              <User size={16}/>

              Username

            </label>

            <div className="input-wrapper">

              <User size={18}/>

              <input

                type="text"

                placeholder="Enter username"

                value={username}

                onChange={(e)=>

                  setUsername(
                    e.target.value
                  )

                }

                required

              />

            </div>

          </div>

          <div className="input-group">

            <label>

              <Lock size={16}/>

              Password

            </label>

            <div className="input-wrapper">

              <Lock size={18}/>

              <input

                type="password"

                placeholder="Enter password"

                value={password}

                onChange={(e)=>

                  setPassword(
                    e.target.value
                  )

                }

                required

              />

            </div>

          </div>
                    <button
            type="submit"
            className="login-button"
          >

            <LogIn size={18} />

            <span>

              Sign In

            </span>

          </button>

        </form>

        <div className="login-footer">

          <small>

            Tally Messenger Subscription Manager

          </small>

          <small>

            Version 1.0.0

          </small>

        </div>

      </div>

    </div>

  );

}
